import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxPermissionsModule } from "ngx-permissions";
import { SecurityPopupComponent } from "./security-popup.component";

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    MatTooltipModule,
    NgxPermissionsModule.forChild()
  ],
  declarations: [SecurityPopupComponent],
  exports: [SecurityPopupComponent]
})
export class SecurityPopupModule {}
